import axios from 'axios';

import Routes from 'src/config/routes';
import type { CommandStatus } from 'src/hooks/command';
import { exceptionFromResponse } from 'src/utils/api';

import { configValues, getConfigValues } from '../config';

export const legacyApi = axios.create({
  baseURL: getConfigValues().SERVER_BASE_URL,
});

export const getAccount = () =>
  legacyApi
    .get('/api/account')
    .then((response) => ({ ...response.data, status: response.status }))
    // This catch method eats the error and causes this functions promise to resolve
    // rather than reject. If we would like to propagate this error then it should be
    // rethrown
    .catch((error) => ({ ...error.response }));

// TODO: remove
export const getAccountListings = (clientId: string) =>
  legacyApi
    .get(`/api/account/${clientId}/listings`, {
      headers: {
        Accept: 'application/json',
      },
    })
    .then((response) => response.data);

// TODO: remove
export const getListingStats = (listingId: string) =>
  legacyApi
    .get(`/api/listing/${listingId}/stats`, {
      headers: {
        Accept: 'application/json',
      },
    })
    .then((response) => ({ ...response.data }))
    .catch((error) => ({ code: error.response.request.status }));

export const getSecureAsset = (assetKey: string) =>
  legacyApi
    .get(`/asset?key=${assetKey}`, {
      headers: {
        Accept: 'application/json',
      },
    })
    .then((response) => response.data as string)
    .catch(() => Routes.ERROR_PAGE);

export const postListing = (listingId: string) =>
  legacyApi
    .post(`/api/listing/${listingId}/post`, {
      headers: {
        Accept: 'application/json',
      },
    })
    .then((response) => ({ ...response.data }))
    .catch((error) => {
      throw exceptionFromResponse(error.response);
    });

export const expireListing = (
  listingId: string,
  reason: string,
  comments: string,
) =>
  legacyApi
    .post(
      `/api/listing/${listingId}/expire`,
      { reason, comments },
      {
        headers: {
          Accept: 'application/json',
        },
      },
    )
    .then((response) => ({ ...response.data }))
    .catch((error) => {
      throw exceptionFromResponse(error.response);
    });

export const subscribeUser = (userId: string) =>
  axios
    .post(`${configValues.SUBSCRIPTIONS_API_URL}/user/${userId}/subscribe`)
    .catch((error) => error);

export const unsubscribeUser = (
  setStatus: (status: CommandStatus) => void,
  userId: string,
): void => {
  axios
    .post(`${configValues.SUBSCRIPTIONS_API_URL}/user/${userId}/unsubscribe`)
    .then(() => setStatus && setStatus('SUCCESS'))
    .catch((error) => (setStatus ? setStatus('FAIL') : error));
};

export const sendRecommendationFeedback = (
  token: string,
  message: string,
  listingId: string,
) =>
  axios
    .post(
      `${configValues.INFORMANT_URL}/user/unverified/recommendationPreferences/feedback`,
      {
        message,
        listingId,
      },
      {
        headers: {
          'x-token': token,
        },
      },
    )
    .catch((error) => error);
